import styles from './Footer.module.scss';

import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import ButtonLink from 'src/components/ButtonLink';
import Logo from 'src/components/Logo';
import NavLink from 'src/components/NavLink';

const ListLinkContainer = (props) => (
  <ul {...props} style={{ listStyle: 'none', margin: '0', padding: '0' }}>
      {props.children}
  </ul>
);

const ListLink = (props) => (
  <li>
      <NavLink {...props} to={props.to}>
          {props.children}
      </NavLink>
  </li>
);

const Footer = () => (
  <Container styleName='footer'>
      <Logo />
      <Row style={{marginTop: '40px'}}>
          <Col md='3' xs='6' styleName='link-container-column'>
              <strong>Features</strong>
              <ListLinkContainer>
                  <ListLink to='/features/dashboard'>
                      Dashboard
                  </ListLink>
                  <ListLink to='/features/reporting'>
                      Reporting
                  </ListLink>
                  <ListLink to='/features/auditing'>
                      Auditing
                  </ListLink>
                  <ListLink to='/features/optimization'>
                      Optimization
                  </ListLink>
                  <ListLink to='/features/carrier-agnostic'>
                      Carrier agnostic
                  </ListLink>
                  <ListLink to='/features/payments'>
                      Payments
                  </ListLink>
                  <ListLink to='/features/teams'>
                      Teams
                  </ListLink>
                  <ListLink to='/features/api'>
                      API
                  </ListLink>
              </ListLinkContainer>
          </Col>
          <Col md='3' xs='6' styleName='link-container-column'>
              <strong>About</strong>
              <ListLinkContainer>
                  <ListLink to='/#savings'>Savings</ListLink>
                  <ListLink to='/#testimonials'>Testimonials</ListLink>
                  <ListLink to='/contact'>Contact us</ListLink>
                  <ListLink to='https://galleon.mightyrecruiter.com/' target='_blank'>Join the team!</ListLink>
              </ListLinkContainer>
          </Col>
          <Col md='3' xs='6' styleName='link-container-column'>
              <strong>Help</strong>
              <ListLinkContainer>
                  <ListLink to='/contact'>Contact us</ListLink>
                  <ListLink to='/privacy-policy'>Privacy Policy</ListLink>
                  <ListLink to='/terms-of-service'>Terms of Service</ListLink>
              </ListLinkContainer>
          </Col>
          <Col md='3' xs='12' styleName='link-container-column login-column'>
              <a href='https://cloud.galleonlogistics.com'>
                  Log in
              </a>
              <ButtonLink to='/contact'>
                  Sign up
              </ButtonLink>
          </Col>
      </Row>
      <div className='text-muted' style={{marginTop: '40px'}}>
          Copyright &copy; {new Date().getFullYear()} Galleon Logistics.
          San Francisco, California, USA. All rights reserved.
      </div>
  </Container>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/Footer.js